import { createContext, useContext } from 'react';

import { ColumnContextProps } from './types';

export const GridColumnContext = createContext<ColumnContextProps>({ column: { label: '' } });

export const useGridColumnContext = () => useContext(GridColumnContext) as ColumnContextProps;
